/**
 * Lead import preview for "How it builds up" Step 1 — Import / Leads come in.
 * Presentational mock: import CSV / connect Meta. Visually distinct from Step 2 (Today).
 */

import * as React from "react";
import { FileSpreadsheet, Link2 } from "lucide-react";

export function LeadImportPreview() {
  return (
    <div className="pointer-events-none select-none min-h-[320px] flex flex-col bg-[#0b0b0f] p-5 text-left dark">
      <p className="text-xs font-medium uppercase tracking-wider text-white/50 mb-3">
        Bring leads in
      </p>
      <div className="space-y-3">
        <div className="flex items-center gap-3 rounded-lg border border-white/10 bg-white/[0.04] px-4 py-3">
          <FileSpreadsheet className="h-5 w-5 text-white/70 shrink-0" />
          <div>
            <p className="text-sm font-medium text-white/90">Import CSV</p>
            <p className="text-xs text-white/50">Upload your leads in one go</p>
          </div>
        </div>
        <div className="flex items-center gap-3 rounded-lg border border-white/10 bg-white/[0.04] px-4 py-3">
          <Link2 className="h-5 w-5 text-white/70 shrink-0" />
          <div>
            <p className="text-sm font-medium text-white/90">Connect Meta</p>
            <p className="text-xs text-white/50">Leads from Meta Lead Ads</p>
          </div>
        </div>
      </div>
      <p className="mt-4 text-xs text-white/40">
        Today can decide what to do once leads are in.
      </p>
    </div>
  );
}
